import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";

import * as Dialog from "@/components/dialog/DialogLayout";
import { useStore } from "@/store";

import { CreateTeamFlow } from "./CreateTeamFlow";

export const CreateTeamDialog = observer(function CreateTeamDialog() {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;
  const { isOpen } = createTeamDialog;

  const handleClose = () => {
    runInAction(() => {
      createTeamDialog.close();
    });
  };

  return (
    <Dialog.Root open={isOpen} onClose={handleClose}>
      <Dialog.Backdrop />
      <Dialog.Container>
        <Dialog.Panel className="overflow-y-auto w-full h-full rounded-none p-0">
          <CreateTeamFlow withHeader />
          <Dialog.CloseButton>
            <Dialog.CloseIcon />
          </Dialog.CloseButton>
        </Dialog.Panel>
      </Dialog.Container>
    </Dialog.Root>
  );
});
